import { StageData } from '../../game/StageLoader';

export const stage03: StageData = {
  id: 'stage_03',
  name: 'ステージ3: 山岳奇襲',
  nameEn: 'Mountain Assault',
  description: '山岳地帯の精鋭部隊を殲滅せよ',
  terrain: 'mountain',
  mapWorld: 6000,
  totalEnemies: 7,
  enemies: [
    // ── ウェーブ1: 精鋭機×3（個別配置）+ 砲台×2 ──
    { type: 'elite',   pos: [    0, 1500, -800] },  // 北
    { type: 'elite',   pos: [  800, 1400,  600] },  // 東
    { type: 'elite',   pos: [ -700, 1600,  200] },  // 西

    // ── 対空砲台（ミサイル発射） ──
    { type: 'turret',   pos: [  200,   -1,   200] },
    { type: 'turret',   pos: [ -800,   -1,   600] },
  ],
  waves: [
    // ── ウェーブ2: 精鋭機×2（編隊） ──
    [
      { type: 'elite',   pos: [ -400, 1800, -600] },
      { type: 'elite',   pos: [ -550, 1750, -450] },
    ],
  ],
};
